import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import {AppConfigKeyVo} from '../../common/shared/api/nicolas/vo/enums/AppConfigKeyVo.enum';
import type {AppSettingInput} from '../../graphql/generated/types';

/**
 * 앱 설정
 *
 * Origin: pageNicolasApi.setAppSetting
 * API: POST /api/v1/app/setting
 */
export async function postAppSetting(
  input: AppSettingInput,
  options?: FetcherOptions
): Promise<ApiResultVo | undefined> {
  const keys = [];
  const values = [];

  if (input.tastesHome) {
    keys.push(AppConfigKeyVo.TastesHome);
    values.push(input.tastesHome);
  }

  if (input.tastesGenre) {
    keys.push(AppConfigKeyVo.TastesGenre);
    values.push(input.tastesGenre);
  }

  if (input.tastesServiceLang) {
    keys.push(AppConfigKeyVo.TastesServiceLang);
    values.push(input.tastesServiceLang);
  }

  if (keys.length === 0) {
    return;
  }

  const response = await axiosBffFetch(
    '/api/gateway/api/v1/app/setting',
    {
      method: 'POST',
      data: {
        keys: keys.toString(),
        values: values.toString(),
      },
    },
    options
  );
  return response.data;
}
